import { ZOperatorDefinition } from "../types/ZFilterMetadataTypes";

export const operatorRequiresValue = (
  operatorCode: string,
  operators: ZOperatorDefinition[],
): boolean => {
  const operator = operators.find((op) => op.code === operatorCode);
  return operator ? operator.requiresValue : true;
};
